import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Clock, ArrowUpRight } from "lucide-react";
import { NAV, EMAIL, HORARIO, SOCIAL, BUY_URL } from "@/data";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-ink text-white">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
                    {/* Brand */}
                    <div className="lg:col-span-2 max-w-md">
                        <img
                            src="/images/logo.webp"
                            alt="El Cometa Bis"
                            className="h-10 w-auto object-contain"
                        />
                        <p className="mt-5 text-sm leading-relaxed text-white/60">
                            Viajá seguro, viajá mejor. Pasajes de larga distancia,
                            encomiendas y turismo con la confianza de El Cometa
                            Bis.
                        </p>
                        <div className="mt-6 flex gap-3">
                            <a
                                href={SOCIAL.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-instagram"
                                aria-label="Instagram"
                                className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-brand"
                            >
                                <Instagram className="h-5 w-5" />
                            </a>
                            <a
                                href={SOCIAL.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-facebook"
                                aria-label="Facebook"
                                className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-brand"
                            >
                                <Facebook className="h-5 w-5" />
                            </a>
                        </div>
                    </div>

                    {/* Nav */}
                    <div>
                        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-brand">
                            Navegación
                        </h4>
                        <ul className="mt-5 space-y-3">
                            {NAV.map((item) => (
                                <li key={item.to}>
                                    <Link
                                        to={item.to}
                                        className="text-sm text-white/70 transition-colors hover:text-white"
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-brand">
                            Contacto
                        </h4>
                        <ul className="mt-5 space-y-4">
                            <li className="flex items-start gap-3 text-sm text-white/70">
                                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                                <a href={`mailto:${EMAIL}`} className="hover:text-white break-all">
                                    {EMAIL}
                                </a>
                            </li>
                            <li className="flex items-start gap-3 text-sm text-white/70">
                                <Clock className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                                Atención: {HORARIO}
                            </li>
                        </ul>
                        <div className="mt-6 flex flex-col gap-2">
                            <a
                                href={BUY_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-1.5 text-sm font-semibold text-white hover:text-brand"
                            >
                                Comprar pasajes <ArrowUpRight className="h-4 w-4" />
                            </a>
                            <Link
                                to="/encomiendas"
                                className="inline-flex items-center gap-1.5 text-sm font-semibold text-white hover:text-brand"
                            >
                                Encomiendas <ArrowUpRight className="h-4 w-4" />
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row">
                    <p className="text-xs text-white/50">
                        © 2026 El Cometa Bis. Todos los derechos reservados.
                    </p>
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">
                        Viajá seguro · Viajá mejor
                    </p>
                </div>
            </div>
        </footer>
    );
}
